import { DEFAULT_PROVIDER, MAX_LOG, type ProviderSettings, type ProviderStore, type UsageEntry } from "./types";

export class MemoryProviderStore implements ProviderStore {
  private s: ProviderSettings = structuredClone(DEFAULT_PROVIDER);
  async get(): Promise<ProviderSettings> { return structuredClone(this.s); }
  async set(s: ProviderSettings): Promise<void> { this.s = structuredClone(s); }
  async appendLog(e: UsageEntry): Promise<void> { this.s.usageLog = [...this.s.usageLog, e].slice(-MAX_LOG); }
}
